var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"18","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#fff","d":"M20 8V0h-7v3H7V0H0v8h7V5h2v10h4v3h7v-8h-7v3h-2V5h2v3z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }